import { Component, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormDateField } from './form-date.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';

@Component({
  selector: 'gio-form-date',
  templateUrl: './form-date.component.html',
  styleUrls: ['./form-date.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormDateComponent<N = any> extends FormBaseComponent<FormDateField<N>> {

  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }


  controlError = '';
  constructor(
    cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    const control = this.service.form.controls[this.field.name as any];
    this.subscribe = control.valueChanges.subscribe((value) => {
      this.controlError = '';

      if (control.errors){
        let minError: { actual: moment.Moment, min: moment.Moment } = control.errors['matDatepickerMin'];
        let maxError: { actual: moment.Moment, max: moment.Moment } = control.errors['matDatepickerMax'];

        if (minError) {
          this.controlError = `A data deve ser igual ou posterior à ${minError.min.format('DD/MM/YYYY')}`;
        }

        if (maxError) {
          this.controlError = `A data deve ser igual ou inferior à ${maxError.max.format('DD/MM/YYYY')}`;
        }
      }
    })

  }
  onComponentDestroy() { }

}
